import {
  useLogin,
  useForgotPassword,
  useResetPassword,
  useRegister,
  useUsers,
  useDeleteUser,
  useUpdateUser,
} from "./auth";
import { usePost, useUpdatePost, useAddPost, useDeletePost } from "./post";
import {
  useComment,
  useUpdateComment,
  useAddComment,
  useDeleteComment,
} from "./comment";
import {
  useCategory,
  useAddCategory,
  useDeleteCategory,
  useUpdateCategory,
} from "./category";

export const hooks = {
  useLogin,
  usePost,
  useUpdatePost,
  useForgotPassword,
  useResetPassword,
  useRegister,
  useCategory,
  useAddCategory,
  useDeleteCategory,
  useUpdateCategory,
  useAddPost,
  useDeletePost,
  useUsers,
  useDeleteUser,
  useUpdateUser,
  useComment,
  useUpdateComment,
  useAddComment,
  useDeleteComment,
};
